import { isIos } from "@/utils/lodash";
import { randomNum } from "@/utils/num_utils";
import LaunchHelpers from "@/utils/launch_helpers";

// 判断是否是iphoneX系列的手机
export const isIphoneX = () => {
  const deviceInfo = getDeviceInfo();
  const statusBar = deviceInfo && deviceInfo.status_bar_height;
  return !!(statusBar > 20 && isIos());
};

export const getDeviceInfo = () => {
  const deviceInfo = LaunchHelpers.getLaunchData();
  return deviceInfo;
};

export const getLaunchParams = () => {
  const launchParams = LaunchHelpers.getLaunchData();
  return launchParams;
};

/**
 * 广告 id
 */
export const getIDFA = () => {
  const deviceInfo = getDeviceInfo();
  const { advertising_identifier } = deviceInfo;
  return advertising_identifier;
};

/**
 * 获取设备id
 */
export const getDeviceId = () => {
  const deviceInfo = getDeviceInfo();
  const { device_id } = deviceInfo;
  return device_id;
};

export const getBundleId = () => {
  return getDeviceInfo().info.identifier;
};

export const getIDFV = () => {
  const deviceInfo = getDeviceInfo();
  const { device } = deviceInfo;
  const { identifier_for_vendor } = device;
  return identifier_for_vendor;
};

export const getShortVersion = () => {
  return getDeviceInfo().info && getDeviceInfo().info.short_version;
};

export const getNativeCodeVersion = () => {
  return getDeviceInfo().native_code_version;
};

export const getAppPlatform = () => {
  return getDeviceInfo().app_platform;
};

export const getSystemVersion = () => {
  return getDeviceInfo().device.system_version;
};

export const getMachine = () => {
  return getDeviceInfo().machine;
};

export const getLang = () => {
  return getDeviceInfo().locale.language_code;
};

export const getNotification = () => {
  const launchParams = getLaunchParams();
  return launchParams && launchParams.hasOwnProperty("notification")
    ? launchParams.notification
    : null;
};

export const getDisplayName = () => {
  return getDeviceInfo().info.display_name;
};
